import * as classnames from 'classnames'
import * as React from 'react'
import ga from '../../../../common/utils/ga'

import SearchLinkContainer from '../../../containers/searchLinkContainer'
import { ICta, IHomePageBlockComponent } from '../../../../typings/pageBlocks'
import Button from '../../../../client/components/button'

import * as styles from './textCategoriesBlock.module.css'
import { Link } from 'react-router-dom'

const reportClick = (label: string) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'Block interaction;CategoryText',
    eventAction: 'click;link',
    eventLabel: label
  })
}

interface ITile {
  title: string
  subtitle: string
  category: string
}

interface IProps extends IHomePageBlockComponent {
  data: ITile[]
  cta: ICta
}

const TextCategoriesBlock = ({ data, cta }: IProps) => {
  return (
    <section className={styles.root}>
      <div className={styles.tabbedTableWrapper}>
        <div className={styles.tabsWrapper}>{'Browse Popular Categories'}</div>

        <div className={classnames(styles.tabContent)}>
          {data.map((category, index) => (
            <SearchLinkContainer
              key={index}
              className={styles.tabbedContentLink}
              locationParams={{ category: category.category }}
              onClick={() => reportClick(category.title)}
            >
              <span className={styles.linkInner}>{category.title}</span>
            </SearchLinkContainer>
          ))}
        </div>
      </div>

      <footer className={styles.footer}>
        <Button
          large
          type={Button.Type.Primary}
          to={cta.url}
          renderAs={Link}
          onClick={() => reportClick(cta.title)}
        >
          {cta.title}
        </Button>
      </footer>
    </section>
  )
}

export default TextCategoriesBlock
